import Swiper from 'swiper/bundle';
const sliders = {
    init() {



        const jsSwiperInit = $('.js-swiper-init');

        jsSwiperInit.each(function() {
            var swiper = new Swiper(this, {  // Use 'this' directly, which refers to the DOM element in this context
                fadeEffect: { crossFade: true },
                virtualTranslate: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: true,
                },
                speed: 2000,
                slidesPerView: 1,
                effect: "fade"
            });
        });

        const jsProductsSlider = $('.js-swiper-products-init');
        jsProductsSlider.each(function() {
            var swiper = new Swiper(this, {  // Use 'this' directly, which refers to the DOM element in this context
                slidesPerView: 1,
                spaceBetween: 30,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                },
                breakpoints: {
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.5,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 3,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 4,
                    }
                }
            });
        });

        const jsGallerySlider = $('.js-swiper-gallery-init');
        jsGallerySlider.each(function() {
            var swiper = new Swiper(this, {
                // Optional parameters
                initialSlide: 1,
                loop: true,
                slidesPerView: 1.5,
                spaceBetween: 15,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 4,
                    }
                }
            });
        });

        const jsInspoSlider = $('.js-swiper-inspiration-init');
        jsInspoSlider.each(function(index, el) {
            var swiper = new Swiper(this, {
                // Optional parameters
                loop: true,
                slidesPerView: 1.5,
                spaceBetween: 15,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                speed: 2000,
                breakpoints: {
                    // when window width is >= 768px
                    992: {
                        slidesPerView: 2,
                    },
                }
                // Navigation arrows
            });
        });

        const jsSingleProductSwiperEl = $('.js-swiper-single-product-init')[0];
        const thumbsEl = $('.js-swiper-single-thumbnails-init')[0];

        // Initialize the thumbnails swiper first
        var jsSliderThumbnail = new Swiper(thumbsEl, {
            slidesPerView: 4,
            freeMode: true,
            spaceBetween: 18,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });

        // Then initialize the main product swiper
        var swiper = new Swiper(jsSingleProductSwiperEl, {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            // Navigation arrows
            thumbs: {
                swiper: jsSliderThumbnail
            }
        });


        // Only initialize Swiper if the viewport width is less than or equal to 767 pixels

            const sswiper = new Swiper('.js-swiper-cards-init', {
                slidesPerView: 1.2,
                breakpoints: {
                    600: {
                        slidesPerView: 2.5,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }
            });
    }
}

export {sliders}
